export const notification_type_en = {
  game_new: "New Game",
  game_updated: "Updated Game",
};
